import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const InsightPickStyle = styled('div')`
  ${media.desktop} {
    display: flex;
  }
  .insightpick {
    &--image {
      background-image: url(${(props: { image: string }) => (props.image ? props.image : '')});
      background-size: cover;
      background-position: center;
      background-color: rgba(51, 51, 51, 0.03);
      ${media.mobile} {
        height: calc((100vw - 40px) / 1.675);
      }
      ${media.desktop} {
        width: 536px;
        height: 367px;
        flex: none;
      }
    }
    &--content-wrap {
      ${media.desktop} {
        width: 408px;
        flex: none;
      }
    }
    &--subtitle {
      font-family: 'Pretendard-Bold';
      font-size: 12px;
      color: #ff5500;
      border-bottom: 1px solid #ff5500;
      width: 94px;
      margin-top: 10px;
      ${media.desktop} {
        margin: 63px auto 0;
      }
    }
    &--title {
      font-family: 'Pretendard-Bold';
      font-size: 20px;
      color: #333333;
      margin-top: 7px;
      word-break: keep-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      max-height: 60px;
      overflow: hidden;
      ${media.desktop} {
        max-height: 64px;
        text-align: center;
        max-width: 297px;
        margin: 11px auto 0;
        font-size: 24px;
        line-height: 32px;
      }
    }
    &--description {
      font-size: 13px;
      line-height: 20px;
      color: #757575;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      max-height: 60px;
      overflow: hidden;
      margin-top: 8px;
      ${media.desktop} {
        width: 312px;
        margin: 16px auto 0;
        font-size: 14px;
        line-height: 22px;
        max-height: 66px;
      }
    }
    &--tags {
      display: flex;
      flex-wrap: wrap;
      margin-top: 16px;
      margin-left: -18px;
      ${media.desktop} {
        max-width: 297px;
        justify-content: center;
        margin: 48px auto 0;
      }
    }
    &--tag {
      font-size: 12px;
      color: #999999;
      margin-left: 18px;
    }
  }
`;

export default InsightPickStyle;
